import React from "react";

// Logo institucional España Eficiente (E²) — imagen de marca real.
export default function Logo({ className = "h-12" }) {
  return (
    <img
      src="/logo-e2.png"
      alt="España Eficiente E² · Ideas · Datos · Soluciones"
      data-testid="site-logo"
      className={`${className} w-auto rounded-md object-contain`}
    />
  );
}
